module.exports = __webpack_public_path__ + "img/footer-logo1.95023b3a.png";